import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SignUser } from "../interfaces/user.type";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private http: HttpClient) {}
  postLogin(data) {
    return this.http.post(`${environment.service_query_url}/login/`, data);
  }
  changePassword(data) {
    return this.http.put(`${environment.service_query_url}/changepassword`, data);
  }
  register(user: SignUser) {
    return this.http.post(`${environment.service_query_url}/register/`, user);
}
logout(): void {
  localStorage.removeItem('authToken'); 
}
 
}